import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ManhwaCard from '@/components/base/ManhwaCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import FadeIn from '@/components/base/FadeIn';
import { usePageMeta } from '@/hooks/usePageMeta';
import { featuredManhwa, categories, testimonials, stats } from '@/mocks/manhwa';

export default function Home() {
  usePageMeta({
    title: '韩漫大全漫画网下拉式免费_无删减韩漫下拉式在线-虚空韩漫网',
    description: '虚空韩漫网支持下拉式免费阅读，韩漫大全漫画无删减下拉式在线观看，跨设备同步进度，让您随时随地无缝阅读。收录超15,800部韩漫作品。',
    keywords: '韩漫大全漫画网下拉式免费,无删减韩漫下拉式在线,虚空韩漫网,韩漫免费阅读,韩国漫画',
    canonicalUrl: 'http://jiukuguoji.com/',
    ogType: 'website',
  });
  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20artistic%20illustration%20with%20soft%20flowing%20gradients%20of%20golden%20amber%20and%20warm%20cream%20colors%2C%20geometric%20shapes%20and%20curved%20lines%20creating%20a%20dreamy%20atmosphere%2C%20stylized%20minimalist%20composition%2C%20digital%20art%20with%20organic%20textures%2C%20no%20text%2C%20clean%20and%20elegant%20aesthetic%2C%20suitable%20for%20a%20reading%20platform%20hero%20background&width=1920&height=1080&seq=hero-home-bg&orientation=landscape"
            alt="虚空韩漫网 - 韩漫在线阅读平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 text-center">
            <h1 className="text-2xl md:text-5xl font-heading font-black text-white tracking-wider mb-3 md:mb-5 leading-tight">
              <span className="block">韩漫大全 · 下拉式免费阅读</span>
            </h1>
            <p className="text-sm md:text-lg text-white/80 font-body max-w-2xl leading-relaxed mb-6 md:mb-8">
              无删减韩漫下拉式在线观看，跨设备同步进度<br className="hidden md:block" />
              让您随时随地无缝阅读，尽享韩漫魅力
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/category/romance"
                className="group inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-rocket-line"></i></span>
                开始阅读
                <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform"><i className="ri-arrow-right-up-line"></i></span>
              </Link>
              <Link
                to="/about"
                className="px-7 py-3 border border-white/40 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <FadeIn direction="up" delay={0.1}>
          <section className="relative -mt-12 z-20 w-full max-w-[1280px] mx-auto px-4 md:px-6 mb-10">
            <div className="bg-white rounded-xl border border-background-200 grid grid-cols-2 md:grid-cols-4 divide-x divide-background-200 overflow-hidden">
              <div className="p-4 md:p-6 text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stats.totalUsers.toLocaleString()}+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">注册用户</div>
              </div>
              <div className="p-4 md:p-6 text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stats.totalWorks.toLocaleString()}+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">收录作品</div>
              </div>
              <div className="p-4 md:p-6 text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stats.dailyVisits.toLocaleString()}+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">日均访问</div>
              </div>
              <div className="p-4 md:p-6 text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stats.weeklyUpdates.toLocaleString()}+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">每周更新</div>
              </div>
            </div>
          </section>
        </FadeIn>

        {/* Feature Grid - Category Entrance */}
        <FadeIn direction="up" delay={0.15}>
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-16">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-8 md:mb-10">
            <div>
              <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
                探索漫画世界
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl">
                八大热门分类，海量韩漫资源，找到属于你的故事。
              </p>
            </div>
            <Link
              to="/category/romance"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部分类
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {categories.map((cat) => {
              const colorMap: Record<string, string> = {
                primary: 'bg-primary-100 text-primary-700 border-primary-200 hover:border-primary-400',
                accent: 'bg-accent-100 text-accent-700 border-accent-200 hover:border-accent-400',
                secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200 hover:border-secondary-400',
              };
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`group flex flex-col items-center gap-2 p-4 md:p-6 rounded-xl border transition-all duration-300 cursor-pointer ${colorMap[cat.color] || colorMap.primary}`}
                >
                  <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                    <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                  </span>
                  <span className="text-sm md:text-base font-medium whitespace-nowrap">{cat.name}</span>
                  <span className="text-xs opacity-70">{cat.count.toLocaleString()}部</span>
                </Link>
              );
            })}
          </div>
        </section>
        </FadeIn>

        {/* Hot Recommendations - Grid */}
        <FadeIn direction="up" delay={0.2}>
        <section className="w-full bg-background-100 py-10 md:py-16">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-8 md:mb-10">
              <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
                热门推荐
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-2">
                编辑精选 · 每日更新 · 品质保证
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
              {featuredManhwa.map((item) => (
                <ManhwaCard key={item.id} {...item} />
              ))}
            </div>
            <div className="mt-8 text-center">
              <Link
                to="/category/fantasy"
                className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-foreground-700 border border-foreground-300 rounded-full hover:bg-foreground-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看更多热门
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
            </div>
          </div>
        </section>
        </FadeIn>

        {/* Editor's Pick - Featured Cards */}
        <FadeIn direction="up" delay={0.25}>
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-16">
          <div className="mb-8 md:mb-10">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
              编辑力荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-2">
              本周不容错过的精彩作品
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-product-shop="">
            <div className="md:col-span-1 md:row-span-2">
              <ManhwaCard variant="featured" {...featuredManhwa[2]} />
            </div>
            {featuredManhwa.slice(0, 2).map((item) => (
              <ManhwaCard key={item.id} variant="featured" {...item} />
            ))}
            {featuredManhwa.slice(3, 5).map((item) => (
              <ManhwaCard key={item.id} variant="featured" {...item} />
            ))}
          </div>
        </section>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn direction="up" delay={0.3}>
        <section className="w-full bg-background-100 py-10 md:py-16">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-8 md:mb-10">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3">
                读者口碑
              </span>
              <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
                数百万读者的共同选择
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-2">
                看看大家怎么说
              </p>
            </div>
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
              {testimonials.map((item) => (
                <div key={item.id} className="break-inside-avoid mb-4 md:mb-5 bg-white rounded-xl border border-background-200 p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                      <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                      <div className="text-xs text-foreground-500">@{item.name}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;{item.comment}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
        </FadeIn>

        {/* CTA Section */}
        <section className="relative w-full py-16 md:py-24 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20gradient%20abstract%20art%20background%20with%20flowing%20organic%20shapes%20in%20golden%20amber%20and%20warm%20peach%20tones%2C%20dreamy%20and%20inviting%20atmosphere%2C%20digital%20minimalist%20composition%2C%20clean%20elegant%20design%2C%20suitable%20for%20call%20to%20action%20section%20background&width=1920&height=800&seq=cta-home-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
          <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-4xl font-heading font-black text-white tracking-wide mb-3 md:mb-4">
              准备好开始阅读了吗？
            </h2>
            <p className="text-sm md:text-lg text-white/80 mb-7 md:mb-9 max-w-xl mx-auto leading-relaxed">
              加入数百万韩漫爱好者，在虚空韩漫网发现你的下一个最爱
            </p>
            <Link
              to="/category/romance"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-book-open-line"></i></span>
              免费开始阅读
              <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform"><i className="ri-arrow-right-up-line"></i></span>
            </Link>
          </div>
        </section>
      </main>

      <Footer />

      <SchemaOrg type="WebPage" data={{
        url: 'http://jiukuguoji.com/',
        name: '虚空韩漫网 - 韩漫大全下拉式免费阅读',
        description: '虚空韩漫网支持下拉式免费阅读，韩漫大全漫画无删减下拉式在线观看，跨设备同步进度。',
        isPartOf: { '@type': 'WebSite', name: '虚空韩漫网', url: 'http://jiukuguoji.com/' },
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          { '@type': 'Question', name: '虚空韩漫网支持哪些阅读方式？', acceptedAnswer: { '@type': 'Answer', text: '虚空韩漫网支持下拉式免费阅读，无需翻页，纵向滚动即可流畅浏览韩漫内容，跨设备同步阅读进度。' } },
          { '@type': 'Question', name: '韩漫是否有删减？', acceptedAnswer: { '@type': 'Answer', text: '虚空韩漫网提供的所有韩漫均为无删减完整版，确保读者获得原汁原味的阅读体验。' } },
          { '@type': 'Question', name: '如何跨设备同步阅读进度？', acceptedAnswer: { '@type': 'Answer', text: '注册虚空韩漫网账号后，阅读进度会自动同步到云端，您可以在手机、平板、电脑等不同设备无缝切换继续阅读。' } },
        ],
      }} />
    </>
  );
}